module.exports = __webpack_public_path__ + "static/img/notice7.85779eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice7.png
// module id = VLh+
// module chunks = 2